(function(){
    'use strict';

    var forms = $('.form--action-ajax');
    
    forms.on('submit', function(event) {
        event.preventDefault();

        var actionUrl = $(this).attr('action');
        var formData = new FormData(this);

        $.ajax({
            url: actionUrl,
            type: 'POST',
            xhr: function() {
                var myXhr = $.ajaxSettings.xhr();
                return myXhr;
            },
            success: function(html){
                console.log(html);
                if (html.status == 0) {
                    $.colorbox({html:'<div class="popup_form">'+html.data+'</div>'});
                } else {
                    $.colorbox({html:'<div class="popup_form">'+html.data+'</div>'});
                }
            },
            data: formData,
            cache: false,
            contentType: false,
            processData: false
        });
    });

})();